const routes =
    [
        {
            path: '/',
            name:'dashboard',
            component:() => import('@/modules/cms/pages/index/index.vue'),
            meta:{title:'工作台'},
        },
        {
            path: '/siteApplication',
            name:'siteApplicationIndex',
            component:() => import('@/modules/cms/pages/siteApplication/index.vue'),
            meta:{title:'应用管理'},
        },
        {
            path: '/pageSeo',
            name:'pageSeoIndex',
            component:() => import('@/modules/cms/pages/pageSeo/index.vue'),
            meta:{title:'页面SEO'},
        },
        {
            path: '/articleCategory',
            name:'articleCategoryIndex',
            component:() => import('@/modules/cms/pages/articleCategory/index.vue'),
            meta:{title:'文章分类'},
        },
        {
            path: '/article',
            name:'articleIndex',
            component:() => import('@/modules/cms/pages/article/index.vue'),
            meta:{title:'文章列表'},
        },
        {
            path: '/adCategory',
            name:'adCategoryIndex',
            component:() => import('@/modules/cms/pages/adCategory/index.vue'),
            meta:{title:'广告分类'},
        },
        {
            path: '/ad',
            name:'adIndex',
            component:() => import('@/modules/cms/pages/ad/index.vue'),
            meta:{title:'广告列表'},
        },
        {
            path: '/fileCategory',
            name:'fileCategoryIndex',
            component:() => import('@/modules/cms/pages/fileCategory/index.vue'),
            meta:{title:'文件分类'},
        },
        {
            path: '/file',
            name:'fileIndex',
            component:() => import('@/modules/cms/pages/file/index.vue'),
            meta:{title:'文件列表'},
        },
        {
            path: '/tagCategory',
            name:'tagCategoryIndex',
            component:() => import('@/modules/cms/pages/tagCategory/index.vue'),
            meta:{title:'标签分类管理'},
        },
        {
            path: '/tag',
            name:'tagIndex',
            component:() => import('@/modules/cms/pages/tag/index.vue'),
            meta:{title:'标签管理'},
        },
        {
            path: '/nav', // 同时匹配 /nav 和 /nav/index
            name: 'navIndex',
            component: () => import('@/modules/cms/pages/nav/index.vue'),
            meta: { title: '导航菜单' }
        },
        {
            path: '/user',
            name:'userIndex',
            component:() => import('@/modules/cms/pages/user/index.vue'),
            meta:{title:'用户列表'},
        },
        {
            path: '/site',
            name:'siteIndex',
            component:() => import('@/modules/cms/pages/site/index.vue'),
            meta:{title:'站点设置'},
        },
        {
            path: '/website',
            name:'websiteIndex',
            component:() => import('@/modules/cms/pages/website/index.vue'),
            meta:{title:'应用管理'},
        },
        {
            path: '/system',
            name:'systemIndex',
            component:() => import('@/modules/cms/pages/system/index.vue'),
            meta:{title:'系统设置列表'},
        },
        {
            path: '/aiModel',
            name:'aiModelIndex',
            component:() => import('@/modules/cms/pages/aiModel/index.vue'),
            meta:{title:'AI模型管理'},
        },
        {
            path: '/aiAgent',
            name:'aiAgentIndex',
            component:() => import('@/modules/cms/pages/aiAgent/index.vue'),
            meta:{title:'AI对话'},
        },
        {
            path: '/aiAgent/new',
            name:'aiAgentNew',
            component:() => import('@/modules/cms/pages/aiAgent/index.vue'),
            meta:{title:'新建对话'},
        },
        {
            path: '/aiAgent/history',
            name:'aiAgentHistory',
            component:() => import('@/modules/cms/pages/aiAgent/index.vue'),
            meta:{title:'会话记录'},
        },
        {
            path: '/aiSkill',
            name:'aiSkillIndex',
            component:() => import('@/modules/cms/pages/aiSkill/index.vue'),
            meta:{title:'Skill管理'},
        },
        {
            path: '/aiAgentTask',
            name:'aiAgentTaskIndex',
            component:() => import('@/modules/cms/pages/aiAgentTask/index.vue'),
            meta:{title:'自动化任务'},
        },
        {
            path: '/admin',
            name:'adminIndex',
            component:() => import('@/modules/cms/pages/admin/index.vue'),
            meta:{title:'管理员列表'},
        },
        {
            path: '/personal',
            name:'personalIndex',
            component:() => import('@/pages/personal/index.vue'),
            meta:{title:'个人资料'},
        },

        {
            path: '/productCategory',
            name:'productCategoryIndex',
            component:() => import('@/modules/cms/pages/productCategory/index.vue'),
            meta:{title:'商品分类'},
        },
        {
            path: '/product',
            name:'productIndex',
            component:() => import('@/modules/cms/pages/product/index.vue'),
            meta:{title:'商品列表'},
        },
    ]
export default routes

